import { render, staticRenderFns } from "./TreeTable.vue?vue&type=template&id=61e4136d&scoped=true"
import script from "./TreeTable.vue?vue&type=script&lang=ts"
export * from "./TreeTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e4136d",
  null
  
)

export default component.exports